export default __webpack_public_path__ + "static/media/WFHPM-dark.3da4f5f8.svg";